import { FleContinueWrapper, FleLayout } from "components/views/fle/FleLayout"
import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { IlloWelcome } from "components/views/atoms/Illustrations"
import { ContinueArrow, SpacerSwitcher, SwitchH1ToH2 } from "components/views/fle/Molecules"
import { Body } from "components/views/atoms/Bodies"
import { FleLinkWrapper } from "components/views/atoms/Links"
import React from "react"
import L10n from "lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export const NiceToSeeYou = ({ firstName, companyName, onComplete }) => (
  <FleLayout
    bottomContent={
      <FleContinueWrapper>
        <ContinueArrow onClick={onComplete} />
      </FleContinueWrapper>
    }
  >
    <div className="dn db-ns">
      <Spacer height={3.5} />
    </div>
    <div className="db dn-ns">
      <Spacer height={1} />
    </div>
    <FlexRowCenter>
      <IlloWelcome />
    </FlexRowCenter>
    <SpacerSwitcher />
    <SwitchH1ToH2>{l`Welcome to Carrot`}</SwitchH1ToH2>
    <Spacer height={0.5} />
    <Body color="black-80">
      {companyName} has partnered with Carrot, a benefit designed to make family forming more accessible to everyone.
    </Body>
  </FleLayout>
)
